var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    stroke: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 32c0 14.36-11.64 26-26 26C17.642 58 6 46.36 6 32S17.641 6 32 6c14.36 0 26 11.64 26 26z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.68 35.953a1.68 1.68 0 01-1.68-1.68V22.161a1.68 1.68 0 113.36 0v12.112a1.68 1.68 0 01-1.68 1.68zm1.68 4.787a1.68 1.68 0 11-3.361-.001 1.68 1.68 0 013.361.001z",
    fill: "#fff"
  })));
}
export default SvgWarning;